import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import CustomModal from 'components/CustomModal/CustomModal'
import styles from './RecycleApiKeyModal.module.css'

const RecycleApiKeyModal = ({ isOpen, onClose, onSuccess, isLoading: externalLoading }) => {
  const [confirmText, setConfirmText] = useState('')
  const [error, setError] = useState('')
  const confirmationWord = 'REGENERATE'

  useEffect(() => {
    if (isOpen) {
      setConfirmText('')
      setError('')
    }
  }, [isOpen])

  const isConfirmValid = confirmText === confirmationWord

  const handleRecycle = async () => {
    if (!isConfirmValid) {
      setError(`Please enter ${confirmationWord} to confirm`)
      return
    }
    onSuccess && onSuccess()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isConfirmValid) {
      handleRecycle()
    } else if (e.key === 'Escape') {
      onClose()
    }
  }

  return (
    <CustomModal show={isOpen} onHide={onClose} centered size="md" className={styles.modal}>
      <div className="p-4">
        <Modal.Header closeButton className={styles.header}>
          <Modal.Title className={styles.title}>Regenerate API Key?</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          <div className={styles.warningSection}>
            <div className={styles.warningIcon}>⚠️</div>
            <div className={styles.warningContent}>
              <p className={styles.warningText}>
                Regenerating your API key will immediately invalidate your current key. Any applications using the old
                key will stop working.
              </p>
              <p className={styles.confirmText}>
                To confirm, please type <strong>{confirmationWord}</strong> below:
              </p>
            </div>
          </div>

          <div className={styles.inputGroup}>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => {
                setConfirmText(e.target.value)
                if (error) setError('')
              }}
              onKeyDown={handleKeyDown}
              className={styles.input}
              placeholder={confirmationWord}
              aria-label={`Type ${confirmationWord} to confirm API key regenerate`}
              aria-invalid={Boolean(error)}
              aria-describedby={error ? 'regenerate-api-key-error' : undefined}
              autoFocus
              disabled={externalLoading}
            />
            {error && (
              <div id="regenerate-api-key-error" role="alert" className={styles.error}>
                {error}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <Button variant="outline-secondary" onClick={onClose} disabled={externalLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleRecycle}
            disabled={externalLoading || !isConfirmValid}
            className={styles.recycleButton}
          >
            {externalLoading ? 'Regenerating...' : 'Regenerate Key'}
          </Button>
        </Modal.Footer>
      </div>
    </CustomModal>
  )
}

export default RecycleApiKeyModal
